import { useAssignmentRequestsForAssignmentAdditionalDetailsGroup } from './graphql';
import React from 'react';
import { Box, Heading, Text } from '@medely/ui-kit';
import { PostingFieldsGroup } from '@mp/components/postingFieldsGroup/PostingFieldsGroup';
import { Divider } from '@mp/components/divider/Divider';
import { AssignmentAdditionalDetailsInfoIcons } from './components/AssignmentAdditionalDetailsInfoIcons';
import { AssignmentAdditionalOfferDetails } from './components/AssignmentAdditionalOfferDetails';
import { AssignmentFacility } from './components/AssignmentFacility';
import { FragmentType, parseFragmentData } from '@mp/graphql/generated';
import { AssignmentForAssignmentDetailsGql } from '../graphql';

type AssignmentAdditionalDetailsInfoProps = {
  assignment?: FragmentType<typeof AssignmentForAssignmentDetailsGql> | null;
  smallIcon?: boolean;
};

export const AssignmentAdditionalDetailsInfo = ({
  assignment: inputAssignment,
  smallIcon = false,
}: AssignmentAdditionalDetailsInfoProps) => {
  const assignment = parseFragmentData(AssignmentForAssignmentDetailsGql, inputAssignment);

  const { assignmentRequests } = useAssignmentRequestsForAssignmentAdditionalDetailsGroup(
    assignment?.id,
  );
  const bookedOrInProgress = ['booked', 'in_progress'].includes(assignment?.status ?? '');
  const isOffered = assignmentRequests?.some((a) => a.status === 'offer_sent') && assignment?.is_w2;

  return (
    <>
      <Box mb={1} testId="assignment-additional-details">
        <Heading size="s" color="text.primary" testId="assignment-additional-job-details-title">
          Additional shift details
        </Heading>
      </Box>
      <Text size="m" color="text.secondary" testId="assignment-details-additional-job-details-id">
        Assignment ID: {assignment?.id}
      </Text>
      <PostingFieldsGroup postingFieldContents={assignment?.posting_field_contents} />
      {assignment?.jobs_detail && (
        <>
          <Divider />
          <Box py={2}>
            <Text size="m" color="text.primary" testId="assignment-jobs-details-description">
              {assignment.jobs_detail}
            </Text>
          </Box>
        </>
      )}
      <AssignmentAdditionalDetailsInfoIcons assignment={inputAssignment} smallIcon={smallIcon} />
      {isOffered && (
        <Box my={3} testId="assignment-additional-offer-details">
          <AssignmentAdditionalOfferDetails assignment={inputAssignment} />
        </Box>
      )}
      {bookedOrInProgress && (
        <Box mb={2}>
          <AssignmentFacility assignment={inputAssignment} smallIcon={smallIcon} />
        </Box>
      )}
    </>
  );
};
